export default __webpack_public_path__ + "static/media/Instagram.f79e8778.svg";